type Csid = string | number | null | undefined;

/**
 * Compare two conversation/call session IDs that may originate from different
 * sources with different runtime types.
 *
 * Background: `state.telephony.currentCall.csid` arrives from the Twilio
 * voice-sdk as a string, while `conversation.id` and websocket `params.csid`
 * come from the platform APIs as numbers. A bare `===` silently returns `false`
 * when the same logical id is represented in different types, which has
 * historically caused calls to "stick" after being closed and listen-in
 * controls to never enable.
 *
 * Returns `false` when either value is null/undefined so callers can use this
 * without an extra existence check.
 */
export function sameCsid(a: Csid, b: Csid): boolean {
  if (a === null || a === undefined) return false;
  if (b === null || b === undefined) return false;
  return a.toString() === b.toString();
}
